/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Installedsize1Inputs */

const id_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran Terinstal`)
};

const ms_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiz Terpasang`)
};

const da_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installeret Størrelse`)
};

const de_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installierte Größe`)
};

const en_us2_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installed Size`)
};

const es_es2_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño instalado`)
};

const es_mx2_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño instalado`)
};

const fil_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sukat ng Naka-install`)
};

const fr_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille installée`)
};

const it_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione installata`)
};

const hu_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepített méret`)
};

const nl_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geïnstalleerde grootte`)
};

const no_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installert størrelse`)
};

const pl_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmiar po instalacji`)
};

const pt_br2_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho instalado`)
};

const pt_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho instalado`)
};

const ro_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiune instalată`)
};

const fi_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asennettu koko`)
};

const sv_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installerad storlek`)
};

const vi_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kích thước cài đặt`)
};

const tr_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurulu Boyut`)
};

const cs_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalovaná velikost`)
};

const bg_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инсталиран размер`)
};

const ru_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установленный размер`)
};

const uk_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розмір після встановлення`)
};

const ar_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحجم بعد التثبيت`)
};

const hi_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंस्टॉल आकार`)
};

const th_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขนาดที่ติดตั้ง`)
};

const ja_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストールサイズ`)
};

const zh_cn2_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装大小`)
};

const zh_hant1_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝大小`)
};

const ko_builds_table_installedsize1 = /** @type {(inputs: Builds_Table_Installedsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설치 용량`)
};

/**
* | output |
* | --- |
* | "Installed Size" |
*
* @param {Builds_Table_Installedsize1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_installedsize1 = /** @type {((inputs?: Builds_Table_Installedsize1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Installedsize1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_installedsize1(inputs)
	if (locale === "ms") return ms_builds_table_installedsize1(inputs)
	if (locale === "da") return da_builds_table_installedsize1(inputs)
	if (locale === "de") return de_builds_table_installedsize1(inputs)
	if (locale === "en-US") return en_us2_builds_table_installedsize1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_installedsize1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_installedsize1(inputs)
	if (locale === "fil") return fil_builds_table_installedsize1(inputs)
	if (locale === "fr") return fr_builds_table_installedsize1(inputs)
	if (locale === "it") return it_builds_table_installedsize1(inputs)
	if (locale === "hu") return hu_builds_table_installedsize1(inputs)
	if (locale === "nl") return nl_builds_table_installedsize1(inputs)
	if (locale === "no") return no_builds_table_installedsize1(inputs)
	if (locale === "pl") return pl_builds_table_installedsize1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_installedsize1(inputs)
	if (locale === "pt") return pt_builds_table_installedsize1(inputs)
	if (locale === "ro") return ro_builds_table_installedsize1(inputs)
	if (locale === "fi") return fi_builds_table_installedsize1(inputs)
	if (locale === "sv") return sv_builds_table_installedsize1(inputs)
	if (locale === "vi") return vi_builds_table_installedsize1(inputs)
	if (locale === "tr") return tr_builds_table_installedsize1(inputs)
	if (locale === "cs") return cs_builds_table_installedsize1(inputs)
	if (locale === "bg") return bg_builds_table_installedsize1(inputs)
	if (locale === "ru") return ru_builds_table_installedsize1(inputs)
	if (locale === "uk") return uk_builds_table_installedsize1(inputs)
	if (locale === "ar") return ar_builds_table_installedsize1(inputs)
	if (locale === "hi") return hi_builds_table_installedsize1(inputs)
	if (locale === "th") return th_builds_table_installedsize1(inputs)
	if (locale === "ja") return ja_builds_table_installedsize1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_installedsize1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_installedsize1(inputs)
	return ko_builds_table_installedsize1(inputs)
});
export { builds_table_installedsize1 as "builds.table.installedSize" }